module.exports = __webpack_public_path__ + "static/media/p3.f3f44e93.png";